import React, { useState, useEffect ,useRef} from "react";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import COLORS from "../resources/colors/COLORS";
import SessionManager from "../Utils/SessionManager";
import { Redirect, useParams } from "react-router-dom";
import "../css/Admin_css/admin-customize.css";
import "../css/Admin_css/certificate.css";
import myToast from "../Utils/MyToast";
import Iframe from "react-iframe";
import MdlSelectMultipleStudent from "../dialog/MdlSelectMultipleStudent";
import { Modal } from "react-bootstrap";
import BackButton from "../ChildComponent/BackButton";

const EventCertificate = () => {
  const { event_id } = useParams();

  const [loggedIn] = useState(!!localStorage.getItem("token"));
  const [Loading, setLoading] = useState(false);
  const [isOpenSelectStudent, setIsOpenSelectStudent] = useState(false);
  const [showCertificatePreview, setShowCertificatePreview] = useState(false);
  const [mSelectedStudent, setMSelectedStudent] = useState([]);
  const [mCertificateSamples, setMCertificateSamples] = useState([]);
  const [mColorOption, setMColorOption] = useState([]);
  const [FILE_URL, setFILE_URL] = useState("");
  const [FILE_NAME, setFILE_NAME] = useState("");
  const [FILE_DIRECTORY, setFILE_DIRECTORY] = useState("");
  const [EVENT_ID, setEVENT_ID] = useState(event_id);
  const [SELECTED_SAMPLE_ID, setSELECTED_SAMPLE_ID] = useState("");
  const [SELECTED_SAMPLE_POSITION, setSELECTED_SAMPLE_POSITION] = useState(0);
  const [SELECTED_COLOR_POSITION, setSELECTED_COLOR_POSITION] = useState(0);
  const [COLOR_OPTION_ID, setCOLOR_OPTION_ID] = useState("");
  const [eventDetails, setEventDetails] = useState(null);
  const [DOCUMENT_TYPE] = useState("event_certificate");
  const [isOpenEventDialog, setIsOpenEventDialog] = useState(false);
  const [eventList, setEventList] = useState([]);
  const [loadingEvents, setLoadingEvents] = useState(false);
  const [certificateType, setCertificateType] = useState("PARTICIPATION");

  const CERTIFICATE_TYPES = [
    { value: "PARTICIPATION", label: "Participation", title: "CERTIFICATE OF PARTICIPATION", icon: "fa-user-check", color: "#3b82f6" },
    { value: "APPRECIATION", label: "Appreciation", title: "CERTIFICATE OF APPRECIATION", icon: "fa-heart", color: "#ec4899" },
    { value: "ACHIEVEMENT", label: "Achievement", title: "CERTIFICATE OF ACHIEVEMENT", icon: "fa-trophy", color: "#f59e0b" }
  ];
  const [height, setHeight] = useState("300px");
  const iframeRef = useRef(null);
  useEffect(() => {
    getEventDetails();
    getCertificateSamples();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const handleMessage = (event) => {
      if (event.data && event.data.iframeHeight) {
        setHeight(`${event.data.iframeHeight}px`);
      }
    };
    window.addEventListener("message", handleMessage, false);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  const getEventList = () => {
    setLoadingEvents(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "getEventList.php?";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    axios
      .get(URL, {
        params: {
          school_code: SCHOOL_CODE,
        },
      })
      .then((res) => res.data)
      .then((response) => {
        setLoadingEvents(false);
        if (response.api_status === "OK") {
          setEventList(response.data || []);
        } else {
          myToast.notify_warning(response.api_remark);
        }
      })
      .catch(() => {
        setLoadingEvents(false);
        myToast.notify_error("Error loading event list");
      });
  };

  const handleOpenEventDialog = () => {
    setIsOpenEventDialog(true);
    getEventList();
  };

  const handleCloseEventDialog = () => {
    setIsOpenEventDialog(false);
  };

  const handleSelectEvent = (event) => {
    setEventDetails(event);
    setEVENT_ID(event.event_id);
    setIsOpenEventDialog(false);
    window.history.pushState({}, '', `/AdminMain/EventCertificate/${event.event_id}`);
  };

  const getEventDetails = () => {
    if (!event_id) return;
    
    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}getEventDetails.php`;

    axios
      .get(URL, { params: { school_code: SCHOOL_CODE, event_id } })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK") {
          const eventData = Array.isArray(response.data) ? response.data[0] : response.data;
          if (eventData) {
            setEventDetails(eventData);
          } else {
            myToast.notify_warning("No event details found");
          }
        } else {
          myToast.notify_warning(response.api_remark || "Failed to load event details");
        }
      })
      .catch(() => {
        setLoading(false);
        myToast.notify_error("Error loading event details");
      });
  };

  const getCertificateSamples = () => {
    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}getPrintableSample.php`;

    axios
      .get(URL, { params: { school_code: SCHOOL_CODE, document_type: DOCUMENT_TYPE } })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK" && response.data?.length > 0) {
          setMCertificateSamples(response.data);
          setSample(SELECTED_SAMPLE_POSITION, response.data);
        } else {
          myToast.notify_warning(response.api_remark || "No certificate templates found");
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const setSample = (selected_sample_position, samples = mCertificateSamples) => {
    const sample = samples[selected_sample_position];
    if (sample) {
      setFILE_NAME(sample.file_name);
      setFILE_DIRECTORY(sample.file_directory);
      setSELECTED_SAMPLE_ID(sample.sample_id);
      getColorOptions(selected_sample_position, samples, sample.file_name, sample.file_directory, sample.sample_id);
    }
  };

  const getColorOptions = (
    selected_sample_position,
    samples = mCertificateSamples,
    fileName = FILE_NAME,
    fileDirectory = FILE_DIRECTORY,
    sampleId = SELECTED_SAMPLE_ID
  ) => {
    const colorOptions = samples[selected_sample_position]?.color_options || [];
    setMColorOption(colorOptions);
    setColorOptions(SELECTED_COLOR_POSITION, colorOptions, fileName, fileDirectory, sampleId);
  };

  const setColorOptions = (
    selected_position_color_option,
    colorOptions = mColorOption,
    fileName = FILE_NAME,
    fileDirectory = FILE_DIRECTORY,
    sampleId = SELECTED_SAMPLE_ID
  ) => {
    const selectedColor = colorOptions[selected_position_color_option];
    const colorOptionId = selectedColor ? selectedColor.color_option_id : "";
    setCOLOR_OPTION_ID(colorOptionId);

    if (mSelectedStudent.length > 0) {
      setFileUrL(mSelectedStudent, certificateType, fileName, fileDirectory, sampleId, colorOptionId);
    }
  };

  const setFileUrL = (
    students = mSelectedStudent, 
    certType = certificateType,
    fileName = FILE_NAME,
    fileDirectory = FILE_DIRECTORY,
    sampleId = SELECTED_SAMPLE_ID,
    colorOptionId = COLOR_OPTION_ID
  ) => {
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const mStudentIds = students.map((s) => s.student_enrollment_no);
    const session_id = students[0]?.session_id || "";
    const certTitle = CERTIFICATE_TYPES.find((t) => t.value === certType)?.title || "CERTIFICATE OF PARTICIPATION";

    const url = `${process.env.REACT_APP_SERVER_NAME}${fileDirectory}${fileName}?student_ids=${encodeURIComponent(JSON.stringify(mStudentIds))}&session_id=${session_id}&sample_id=${sampleId}&system_code=${process.env.REACT_APP_SYSTEM_CODE}&color_option_id=${colorOptionId}&event_id=${EVENT_ID}&school_code=${SCHOOL_CODE}&certificate_title=${encodeURIComponent(certTitle)}`;
    
    console.log("Certificate URL:", url);
    setFILE_URL(url);
  };

  const changeColor = (index) => {
    setSELECTED_COLOR_POSITION(index);
    setShowCertificatePreview(true);
    setColorOptions(index, mColorOption, FILE_NAME, FILE_DIRECTORY, SELECTED_SAMPLE_ID);
  };

  const changeSample = (position) => {
    setSELECTED_SAMPLE_POSITION(position);
    setShowCertificatePreview(true);
    setSample(position);
  };

  const changeCertificateType = (type) => {
    setCertificateType(type);
    if (mSelectedStudent.length > 0) {
      setShowCertificatePreview(true);
      setFileUrL(mSelectedStudent, type);
    }
  };

  const SelectStudent = () => {
    setIsOpenSelectStudent(true);
  };

  const HandleCloseSelectStudent = () => {
    setIsOpenSelectStudent(false);
  };

  const HandleSelectedStudent = (selectedStudents) => {
    const students = selectedStudents || [];
    setIsOpenSelectStudent(false);
    setShowCertificatePreview(true);
    setMSelectedStudent(students);
    setFileUrL(students);
  };

  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  if (Loading) {
    return <MyLoader />;
  }

  return (
    <div className="content event-certificate">
      <div
        className="content-header"
        style={{ background: COLORS.primary_color_shade5 }}
      >
        <div className="leftside-content-header">
          <ul className="breadcrumbs">
            <li>
              <i
                className="fa fa-home"
                aria-hidden="true"
                style={{ color: COLORS.white }}
              />
              <a href="#" style={{ color: COLORS.white }}>
                Event Certificate
              </a>
            </li>
          </ul>
        </div>
        <div className="rightside-content-header">
          <BackButton />
        </div>
      </div>

      <div className="page-card">
        {/* Modern Header Section */}
        <div className="header-section">
          <div className="header-content">
            <h5>Event Certificate</h5>
            <small>Create beautiful certificates for event participants</small>
          </div>
          <div className="header-icon">
            <i className="fa fa-certificate"></i>
          </div>
        </div>

        {/* Event Details and Student Selection in One Row */}
        <div style={{ display: "flex", gap: "16px", margin: "16px 20px 0 20px" }}>
          {/* Event Details */}
          <div style={{ flex: "1" }}>
            <div className="selection-section">
              <h5 className="section-title">
                <i className="fa fa-calendar" style={{ marginRight: "6px" }} />
                Event Details
              </h5>
              {eventDetails ? (
                <div className="event-details-card">
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "12px" }}>
                    <div style={{ flex: 1 }}>
                      <h4 style={{ margin: "0 0 6px 0" }}>
                        {eventDetails.event_name || eventDetails.name || eventDetails.title || `Event #${EVENT_ID}`}
                      </h4>
                      <p style={{ margin: 0 }}>
                        <strong>Type:</strong>{" "}
                        {eventDetails.event_type ? eventDetails.event_type : 
                         (eventDetails.is_paid === 'Yes' || eventDetails.is_paid === '1' || eventDetails.is_paid === true 
                           ? 'Paid Event' 
                           : 'Free Event')}
                      </p>
                    </div>
                    <button
                      className="selection-button"
                      onClick={handleOpenEventDialog}
                      style={{ marginTop: "0", flexShrink: 0 }}
                    >
                      <i className="fa fa-exchange" />
                      Change
                    </button>
                  </div>
                </div>
              ) : (
                <div className="event-details-card">
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "12px" }}>
                    <div style={{ flex: 1 }}>
                      <h4 style={{ margin: "0 0 6px 0", color: COLORS.grey2 }}>No Event Selected</h4>
                      <p style={{ margin: 0, color: COLORS.grey3 }}>Select an event to create certificates</p>
                    </div>
                    <button
                      className="selection-button"
                      onClick={handleOpenEventDialog}
                      style={{ marginTop: "0", flexShrink: 0 }}
                    >
                      <i className="fa fa-plus" />
                      Select Event
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Student Selection */}
          <div style={{ flex: "1" }}>
            <div className="selection-section select-recipients">
              <h5 className="section-title">
                <i className="fa fa-users" style={{ marginRight: "6px" }} />
                Select Recipients
              </h5>
              <div className="selection-buttons">
                <button
                  className="selection-button"
                  onClick={SelectStudent}
                >
                  <i className="fa fa-user-plus" />
                  Select Students Manually
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Certificate Type Section */}
        <div className="selection-section" style={{ margin: "16px 20px 0 20px" }}>
          <h5 className="section-title">
            <i className="fa fa-award" style={{ marginRight: "6px" }} />
            Certificate Type
          </h5>
          <div className="certificate-type-grid">
            {CERTIFICATE_TYPES.map((type) => (
              <div
                key={type.value}
                className={`certificate-type-item ${certificateType === type.value ? 'active' : ''}`}
                onClick={() => changeCertificateType(type.value)}
                style={{
                  borderColor: certificateType === type.value ? type.color : undefined,
                  background: certificateType === type.value ? `${type.color}08` : undefined
                }}
              >
                <div 
                  className="certificate-type-icon"
                  style={{ background: type.color }}
                >
                  <i className={`fa ${type.icon}`}></i>
                </div>
                <span 
                  className="certificate-type-label"
                  style={{ color: certificateType === type.value ? type.color : undefined }}
                >
                  {type.label}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Templates Section */}
        <div className="selection-section" style={{ margin: "16px 20px 0 20px" }}>
          <h5 className="section-title">
            <i className="fa fa-certificate" style={{ marginRight: "6px" }} />
            Certificate Templates
          </h5>
          <div className="templates-grid">
            {mCertificateSamples.map((item, index) => (
              <div
                key={index}
                className={`template-item ${SELECTED_SAMPLE_POSITION === index ? 'active' : ''}`}
                onClick={() => changeSample(index)}
              >
                <i className="fa fa-certificate template-icon"></i>
                <div className="template-name">{item.sample_name}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Color Options Section */}
        {mColorOption.length > 0 && (
          <div className="selection-section" style={{ margin: "16px 20px 0 20px" }}>
            <h5 className="section-title">
              <i className="fa fa-paint-brush" style={{ marginRight: "6px" }} />
              Color Options
            </h5>
            <div className="color-options">
              {mColorOption.map((item, index) => {
                const [color1, color2] = item.sample_color_code.split("_");
                return (
                  <div
                    key={index}
                    className={`color-option ${SELECTED_COLOR_POSITION === index ? 'active' : ''}`}
                    onClick={() => changeColor(index)}
                  >
                    <div className="color-display">
                      <div style={{ backgroundColor: color1 }}></div>
                      <div style={{ backgroundColor: color2 }}></div>
                    </div>
                    <div className="color-name">{item.sample_color_name}</div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Preview Section */}
        <div className="preview-section" style={{ margin: "16px 20px 20px 20px" }}>
          <h5 className="section-title">
            <i className="fa fa-eye" style={{ marginRight: "6px" }} />
            Preview
          </h5>
          <div className="preview-frame">
            {mSelectedStudent.length === 0 ? (
              <div className="no-students-message">
                <i className="fa fa-user-plus" />
                <h4>No Students Selected</h4>
                <p>Please select students to preview the certificate</p>
              </div>
            ) : (
              <>
                {showCertificatePreview && <MyLoader />}
                
                 <Iframe
            ref={iframeRef}
            src={FILE_URL}
            width="100%"
            height={height}
            style={{ border: "none", overflow: "hidden" }}
            id="iFrame1"
            scrolling="no"
            onLoad={() => setShowCertificatePreview(false)}
          />
              </>
            )}
          </div>
        </div>
      </div>

      {isOpenSelectStudent && (
        <MdlSelectMultipleStudent
          actionClose={HandleCloseSelectStudent}
          actionHandleSelected={HandleSelectedStudent}
        />
      )}

      {/* Event Selection Modal */}
      {isOpenEventDialog && (
        <Modal show={isOpenEventDialog} onHide={handleCloseEventDialog} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="fa fa-calendar" style={{ marginRight: "8px" }} />
              Select Event
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {loadingEvents ? (
              <div style={{ textAlign: "center", padding: "40px" }}>
                <i className="fa fa-spinner fa-spin" style={{ fontSize: "32px", marginBottom: "16px" }} />
                <p>Loading events...</p>
              </div>
            ) : eventList.length > 0 ? (
              <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                {eventList.map((event) => (
                  <div
                    key={event.event_id}
                    onClick={() => handleSelectEvent(event)}
                    style={{
                      padding: "16px",
                      border: "2px solid #e5e7eb",
                      borderRadius: "8px",
                      marginBottom: "12px",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                      backgroundColor: "#fff"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.borderColor = COLORS.primary_color_shade6;
                      e.currentTarget.style.backgroundColor = "#f8fafc";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.borderColor = "#e5e7eb";
                      e.currentTarget.style.backgroundColor = "#fff";
                    }}
                  >
                    <h5 style={{ margin: "0 0 8px 0", color: COLORS.primary_color_shade8 }}>
                      {event.event_name}
                    </h5>
                    <p style={{ margin: "0", color: COLORS.grey2, fontSize: "14px" }}>
                      <strong>Type:</strong> {event.event_type} | 
                      <strong> Date:</strong> {event.start_date} to {event.end_date}
                    </p>
                  </div>
                ))}
              </div>
            ) : (
              <div style={{ textAlign: "center", padding: "40px", color: COLORS.grey3 }}>
                <i className="fa fa-calendar-times" style={{ fontSize: "32px", marginBottom: "16px" }} />
                <p>No events found</p>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <button className="btn secondary" onClick={handleCloseEventDialog}>
              Cancel
            </button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};

export default EventCertificate;
